import React from 'react';
import { AlertList } from './AlertList';
import { ScrollToTop } from './ScrollToTop';

const ResolvedAlerts: React.FC = () => {
  return (
    <div className="relative">
      <AlertList type="resolved" />
      <ScrollToTop />
    </div>
  );
};

export default ResolvedAlerts;